import { IconComponent } from './types';

const PencilIcon: IconComponent = (props) => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5351 7.85014L11.9923 11.0303C12.0253 11.2751 11.951 11.5223 11.7884 11.7082C11.6258 11.8941 11.3908 12.0005 11.144 12H11.0177L7.84118 11.5423C7.4106 11.4828 7.01127 11.284 6.70412 10.9761L0.844402 5.10364C-0.295574 3.92199 -0.27927 2.04369 0.881044 0.882051C2.04136 -0.27959 3.91751 -0.295912 5.09781 0.845367L10.9696 6.71179C11.2771 7.01928 11.4757 7.41907 11.5351 7.85014ZM7.37192 10.3376C7.53832 10.4976 7.74715 10.6063 7.97353 10.6508L11.1079 11.0664L10.6688 7.95253C10.6243 7.72589 10.5157 7.51682 10.3559 7.35023L4.49018 1.48381C4.09496 1.0776 3.55257 0.848487 2.98615 0.848487C2.41973 0.848487 1.87734 1.0776 1.48211 1.48381C1.0857 1.87836 0.862802 2.41488 0.862802 2.9745C0.862802 3.53413 1.0857 4.07065 1.48211 4.4652L7.37192 10.3376Z"
      fill="currentColor"
    />
    <path
      d="M3.26891 2.6342C3.09112 2.46835 2.81408 2.47325 2.64225 2.64527C2.47042 2.8173 2.46554 3.09466 2.6312 3.27264L5.16399 5.80834C5.34016 5.98448 5.62554 5.98448 5.8017 5.80834C5.97765 5.63197 5.97765 5.34626 5.8017 5.1699L3.26891 2.6342Z"
      fill="currentColor"
    />
  </svg>
);

export default PencilIcon;
